import requestTabTemplate from './requestTabTemplate';

export default requestTabTemplate(['request'], ({ requests }) => requests.create);
